import { createContext } from 'react';

export type ActivityOpenNotificationContextType = {
  onOpenActivity: (activityId: number) => void;
  onCloseActivity: (activityId: number) => void;
  openBy: string | undefined;
};

export const ActivityOpenNotificationContext = createContext<ActivityOpenNotificationContextType | null>(null);
ActivityOpenNotificationContext.displayName = 'ActivityOpenNotificationContext';
